/**
 * @file info-profile-component.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la información del perfil de usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-07
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import ButtonComponent from "@/components/ui/ButtonComponent";
import { PencilLineIcon, RotateCcwKey } from "lucide-react";
import { useProfileView } from "@/features/profile";
import { PROFILE_EDIT_MODAL_ID, PROFILE_CHANGE_PASSWORD_MODAL_ID } from "./profile-modal-ids";
export const InfoProfileComponent = () => {
  const $ = _c(44);
  const labels = useTranslations("Labels");
  const buttons = useTranslations("Buttons");
  const toggle = useTranslations("ToggleComponent");
  const {
    isChecked,
    openEditProfileModal,
    openChangePasswordModal,
    isEditProfileModalOpen,
    isChangePasswordModalOpen,
    user
  } = useProfileView();
  let t0;
  if ($[0] !== labels) {
    t0 = labels("labelMail");
    $[0] = labels;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = user?.mail || "-";
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      id: "profile-mail",
      label: t0,
      value: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== labels) {
    t3 = labels("labelName");
    $[5] = labels;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = user?.name || "-";
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      id: "profile-name",
      label: t3,
      value: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== labels) {
    t6 = labels("label2FA");
    $[10] = labels;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isChecked || $[13] !== toggle) {
    t7 = isChecked ? toggle("active") : toggle("deactivate");
    $[12] = isChecked;
    $[13] = toggle;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = {
      id: "profile-2fa",
      label: t6,
      value: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t5 || $[20] !== t8) {
    t9 = [t2, t5, t8];
    $[18] = t2;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const infoFields = t9;
  let t10;
  if ($[22] !== infoFields) {
    t10 = <dl className="modal__details modal__details--static">{infoFields.map(_temp)}</dl>;
    $[22] = infoFields;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isEditProfileModalOpen ? PROFILE_EDIT_MODAL_ID : undefined;
  let t12;
  if ($[24] !== buttons) {
    t12 = buttons("buttonEditProfile");
    $[24] = buttons;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isEditProfileModalOpen || $[27] !== openEditProfileModal || $[28] !== t11 || $[29] !== t12) {
    t13 = <ButtonComponent icon={PencilLineIcon} iconPosition="left" onClick={openEditProfileModal} color="primary" aria-haspopup="dialog" aria-expanded={isEditProfileModalOpen} aria-controls={t11}>{t12}</ButtonComponent>;
    $[26] = isEditProfileModalOpen;
    $[27] = openEditProfileModal;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = isChangePasswordModalOpen ? PROFILE_CHANGE_PASSWORD_MODAL_ID : undefined;
  let t15;
  if ($[31] !== buttons) {
    t15 = buttons("buttonChangePassword");
    $[31] = buttons;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== isChangePasswordModalOpen || $[34] !== openChangePasswordModal || $[35] !== t14 || $[36] !== t15) {
    t16 = <ButtonComponent icon={RotateCcwKey} iconPosition="left" onClick={openChangePasswordModal} color="primary" aria-haspopup="dialog" aria-expanded={isChangePasswordModalOpen} aria-controls={t14}>{t15}</ButtonComponent>;
    $[33] = isChangePasswordModalOpen;
    $[34] = openChangePasswordModal;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t13 || $[39] !== t16) {
    t17 = <div className="profile__content__info--actions">{t13}{t16}</div>;
    $[38] = t13;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t10 || $[42] !== t17) {
    t18 = <div className="profile"><div className="profile__content"><div className="profile__content__info">{t10}{t17}</div></div></div>;
    $[41] = t10;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
};
function _temp(t0) {
  const {
    id,
    label,
    value
  } = t0;
  return <div key={id} className="modal__details__field"><dt id={`${id}-label`} className="label">{label}</dt><dd aria-labelledby={`${id}-label`} className="modal__details__value">{value}</dd></div>;
}